import React from 'react';
import {EditorState, Modifier, convertFromHTML, ContentState, convertFromRaw} from 'draft-js';

const FRAGMENT_ATTR = "data-draftjs-conductor-fragment";

export default function createPastePlugin(config = {}) {

    const store = {
        getEditorState: undefined,
        setEditorState: undefined,
    };

    return {
        initialize: ({ getEditorState, setEditorState }) => {
            store.getEditorState = getEditorState;
            store.setEditorState = setEditorState;
        },
        handlePastedText(text, html, editorState) {
            let newState1;
            if (!!html) {
                const doc = new DOMParser().parseFromString(html, "text/html");
                const fragmentElt = doc.querySelector("[".concat(FRAGMENT_ATTR, "]")); // Handle the paste if it comes from draftjs-conductor.

                let fragment;
                if (fragmentElt) { //paste from draft js
                    const fragmentAttr = fragmentElt.getAttribute(FRAGMENT_ATTR);
                    let rawContent = JSON.parse(fragmentAttr);
                    fragment = convertFromRaw(rawContent).getBlockMap();
                } else { //paste from any other source
                    const blocksFromHTML = convertFromHTML(html);
                    const state = ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap,);
                    fragment = state.getBlockMap();
                }

                newState1 = Modifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);
            } else {
                newState1 = Modifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), text.trim());
            }

            const newState2 = EditorState.push(editorState, newState1, 'insert-characters');

            store.setEditorState(newState2);
            return 'handled';
        }
    };
};